import React from "react";

// An svg downloaded from Figma, wrapped in a React component
// Rendering this component results in an <svg /> on the DOM, so that attributes like stroke color can be styled using CSS
// (Rendering a non-React component svg through <img src={icon.svg} /> results in an img, which can't have svg attributes styled)
export default function IconClose() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 5l14 14M5 19L19 5" stroke="#AAA" strokeWidth="2" />
    </svg>
  );
}
